"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _Modal = _interopRequireWildcard(require("./Modal.styled"));
var _utils = require("../../utils/utils");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
var XSvg = function XSvg(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", props, /*#__PURE__*/_react["default"].createElement("title", null, "X Remove Delete Close Cross Multiply"), /*#__PURE__*/_react["default"].createElement("path", {
    fill: "#25292D",
    d: "M5.147 5.146a.5.5 0 0 1 .707 0l2.13 2.131 2.131-2.13a.5.5 0 0 1 .638-.058l.07.057a.5.5 0 0 1 0 .708L8.69 7.984l2.132 2.131a.5.5 0 0 1 .058.638l-.058.07a.5.5 0 0 1-.707 0L7.984 8.69l-2.13 2.133a.5.5 0 0 1-.638.057l-.07-.057a.5.5 0 0 1 0-.708l2.131-2.131-2.13-2.13a.5.5 0 0 1-.058-.638z"
  }));
};
XSvg.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  viewBox: "0 0 16 16"
};
var modalStack = [];
var Modal = function Modal(_ref) {
  var children = _ref.children,
    onClose = _ref.onClose;
  var modalContainerRef = (0, _react.useRef)();
  (0, _react.useEffect)(function () {
    if (!(0, _utils.scrollLocked)()) {
      (0, _utils.scrollLock)();
      return function () {
        (0, _utils.scrollUnlock)();
      };
    }
  }, []);

  // Handle exit using escape key via eventListener. If enter key is processed here for closing modal, we have problems
  // when enter key press is required for other things like a button (e.g. login modal button).
  var handleKeyDown = function handleKeyDown(e) {
    if (e.keyCode === 27 && onClose) {
      if (modalStack[modalStack.length - 1] == modalContainerRef) {
        onClose(e);
      }
    }
  };

  // Handle exit using enter key via onKeyDown.
  var handleExit = function handleExit(e) {
    if (e.keyCode === 13 && onClose) {
      onClose(e);
    }
  };
  (0, _react.useEffect)(function () {
    window.addEventListener("keydown", handleKeyDown);
    modalStack.push(modalContainerRef);
    var focusableElements = modalContainerRef.current.querySelectorAll('button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])');
    focusableElements[0].focus();
    return function () {
      window.removeEventListener("keydown", handleKeyDown);
      modalStack.splice(modalStack.indexOf(modalContainerRef), 1);
    };
  }, [handleKeyDown]);
  return /*#__PURE__*/_react["default"].createElement(_Modal["default"], {
    role: "dialog",
    "aria-modal": "true",
    className: "modal-component"
  }, /*#__PURE__*/_react["default"].createElement(_Modal.GlobalStyle, null), /*#__PURE__*/_react["default"].createElement("div", {
    className: "modal-filter",
    onClick: onClose
  }), /*#__PURE__*/_react["default"].createElement("div", {
    className: "modal-container",
    ref: modalContainerRef
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "close-modal"
  }, /*#__PURE__*/_react["default"].createElement("span", {
    tabIndex: "0",
    onClick: onClose,
    onKeyDown: handleExit
  }, /*#__PURE__*/_react["default"].createElement(XSvg, null))), /*#__PURE__*/_react["default"].createElement("div", {
    className: "modal-content"
  }, children)));
};
Modal.propTypes = {
  children: _propTypes["default"].oneOfType([_propTypes["default"].arrayOf(_propTypes["default"].node), _propTypes["default"].node]).isRequired,
  onClose: _propTypes["default"].func
};
var _default = exports["default"] = Modal;